import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";
import { useLocation } from "@tanstack/react-router";

export function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  // The review detail page provides its own floating nav dock — don't double up.
  const suppress = /^\/reviews\/[^/]+$/.test(pathname) && pathname !== "/reviews/new";

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (suppress) return null;


  const scroll = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={scroll}
      aria-label="Return to top"
      className={`
        fixed bottom-2 right-2 z-50
        flex items-center justify-center
        h-10 w-10 rounded-full
        bg-primary text-primary-foreground
        shadow-lg backdrop-blur-sm
        transition-all duration-300 ease-out
        hover:scale-110 hover:shadow-xl
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring
        ${
          visible
            ? "translate-y-0 opacity-90 pointer-events-auto"
            : "translate-y-4 opacity-0 pointer-events-none"
        }
      `}
    >
      <ArrowUp className="h-4 w-4" />
    </button>
  );
}
